import { render, staticRenderFns } from "./MNoDataComp.vue?vue&type=template&id=0c90d01a&scoped=true&"
import script from "./MNoDataComp.vue?vue&type=script&lang=js&"
export * from "./MNoDataComp.vue?vue&type=script&lang=js&"
import style0 from "./MNoDataComp.vue?vue&type=style&index=0&id=0c90d01a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c90d01a",
  null
  
)

export default component.exports